<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row>
        <el-col :span="2">
          <div class="grid-content bg-purple">
            <el-button
              class="filter-item"
              type="primary"
              icon="el-icon-edit"
              @click="handleCreate"
            >新增</el-button>
          </div>
        </el-col>
        <el-col :span="22">
          <div class="grid-content bg-purple-light">
            <el-form :inline="true" :model="listQuery" class="demo-form-inline">
              <el-form-item label>
                <el-input v-model="listQuery.shop_name" placeholder="供应商名称" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label>
                <el-input v-model="listQuery.title" placeholder="商品名称" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label>
                <el-select placeholder="套餐" v-model="listQuery.type" :clearable="true">
                  <el-option label="套餐" :value="1"></el-option>
                  <el-option label="路线" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label>
                <el-select placeholder="审核状态" v-model="listQuery.inspect_status" :clearable="true">
                  <el-option label="未审核" value="0"></el-option>
                  <el-option label="通过" value="1"></el-option>
                  <el-option label="驳回" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label>
                <el-select placeholder="是否特价套餐" v-model="listQuery.special_offer" :clearable="true">
                  <el-option label="特价" value="1"></el-option>
                  <el-option label="非特价" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label>
                <el-select placeholder="按权重" v-model="listQuery.sort" :clearable="true">
                  <el-option label="按权重" value="weight"></el-option>
                  <el-option label="按最新" value="created_at"></el-option>
                  <el-option label="按销量" value="sell"></el-option>
                  <el-option label="按库存" value="stock"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label>
                <el-select
                  placeholder="全部一级类目"
                  v-model="listQuery.firstDestination"
                  :clearable="true"
                  @change="getCategoryList(2)"
                  @clear="firstClose"
                >
                  <el-option v-for="item in firstList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-select
                  placeholder="全部二级类目"
                  :clearable="true"
                  v-if="listQuery.firstDestination"
                  v-model="listQuery.secondDestination"
                  style="margin-left:10px"
                  @change="getCategoryList(3)"
                  @clear="secondClose"
                >
                  <el-option v-for="item in secondList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-select
                  placeholder="全部三级类目"
                  :clearable="true"
                  v-if="listQuery.secondDestination"
                  v-model="listQuery.thirdDestination"
                  style="margin-left:10px"
                >
                  <el-option v-for="item in thirdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <!-- {{ scope.row.id }} -->
        </template>
      </el-table-column>
      <el-table-column label="商品id" min-width="110" align="center">
        <template slot-scope="scope">
          {{
          scope.row.id
          }}
        </template>
      </el-table-column>
      <el-table-column label="供应商" min-width="110" align="center">
        <template slot-scope="scope">
          {{
          scope.row.input_shop_id != 0 ? scope.row.shop.name : "平台自营"
          }}
        </template>
      </el-table-column>
      <el-table-column label="套餐标题" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.title }}</template>
      </el-table-column>
      <el-table-column label="商品图片" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.cover" class="user-avatar" />
        </template>
      </el-table-column>
      <el-table-column label="参考价格" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.currency_type == 2">A${{ scope.row.price }}</span>
          <span v-else>￥{{ scope.row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="已售" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.sell }}</template>
      </el-table-column>
      <el-table-column label="库存" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.stock }}</template>
      </el-table-column>
      <el-table-column label="目的地" min-width="120" align="center">
        <template slot-scope="scope">{{ scope.row.first_destination.name+'/'+scope.row.second_destination.name+'/'+scope.row.third_destination.name }}</template>
      </el-table-column>
      <el-table-column label="权重" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.weight }}</template>
      </el-table-column>
      <el-table-column label="类型" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 2">路线</span>
          <span v-else>套餐</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="审核状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.inspect_status == 1" type="success">通过</el-tag>
          <el-tag v-if="scope.row.inspect_status == 0" type="warning">未审核</el-tag>

          <el-tooltip placement="top">
            <div slot="content">驳回原因:{{scope.row.refuse_reason}}</div>
            <el-tag v-if="scope.row.inspect_status == 2" type="danger">驳回</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" style="color:red;">已下架</span>
          <span v-else>正常</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="特价套餐" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.special_offer == 0" style="color:red;">否</span>
          <span v-else>是</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="到期时间" min-width="90" align="center">
        <template slot-scope="scope">
          <span v-if="Date.parse(scope.row.expired) < new Date()" style="color:red;">已过期</span>
          <span v-else>{{scope.row.expired}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column class-name="status-col" label="新品独家" min-width="80" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.new_product == 0" style="color:red;">否</span>
          <span v-else>是</span>
        </template>
      </el-table-column>
      <el-table-column label="排序权重" min-width="80" align="center">
        <template slot-scope="scope">{{ scope.row.weight }}</template>
      </el-table-column>-->
      <el-table-column label="操作" align="center" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-row>
            <el-button style="margin:5px" type="primary" size="mini" @click="handleShowInfo(scope.row)">查看详情</el-button>
            <el-button
              style="margin:5px"
              type="success"
              size="mini"
              v-if="scope.row.inspect_status == 0"
              @click="examine(scope.row.id,scope.row.refuse_reason)"
            >审核</el-button>
            <el-button style="margin:5px" @click="recommendUpdate(scope.row.id)" size="mini">推荐</el-button>
            <el-button
              style="margin:5px"
              type="danger"
              size="mini"
              @click="weightUpdate(scope.row.id, scope.row.weight)"
            >权重</el-button>
            <el-button style="margin:5px" type="warning" size="mini" @click="handleUpdate(scope.row.id)">修改</el-button>
            <el-button
              style="margin:5px"
              v-if="scope.row.status == 0"
              type="success"
              size="mini"
              @click="upDown(scope.row.id)"
            >上架</el-button>
            <el-button style="margin:5px" v-else type="danger" size="mini" @click="upDown(scope.row.id)">下架</el-button>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="审核"
      :visible.sync="examineVisible"
      :close-on-click-modal="false"
      style="width:500px; top:20%;
            left:30%;"
    >
      <div slot="footer" class="dialog-footer">
        <el-button @click="reasonVisible = true">驳回</el-button>
        <el-button type="primary" :loading="btnLoading" @click="toExamine()">通过</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="驳回"
      :visible.sync="reasonVisible"
      :close-on-click-modal="false"
      style="width:1200px;top:20%;
            left:20%;"
    >
      <el-form
        ref="weight"
        label-position="left"
        label-width="50px"
        style="width: 500px; margin-left:6px;"
      >
        <el-form-item label="驳回原因" prop="weight" label-width="100px">
          <el-input type="textarea" :rows="3" v-model="refuse_reason" placeholder="请输入驳回原因" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reasonVisible = false">取消</el-button>
        <el-button type="primary" @click="refuse" :loading="btnLoading">驳回</el-button>
      </div>
    </el-dialog>
    <el-dialog title="详情" v-if="showInfo" :visible.sync="showInfo">
      <el-form ref="form" :model="info" label-width="120px">
        <!-- <el-form-item label="序号">
          <div>{{ info.id }}</div>
        </el-form-item>-->
        <el-form-item label="商品id">
          <div>{{ info.id }}</div>
        </el-form-item>
        <el-form-item label="供应商">
          <div>{{ info.input_shop_id != 0 ? info.shop.name : "总台" }}</div>
        </el-form-item>
        <el-form-item label="套餐标题">
          <div>{{ info.title }}</div>
        </el-form-item>
        <el-form-item label="商品图片">
          <div>
            <img v-if="info.cover != ''" :src="info.cover" alt style="width: 150px;" />
          </div>
        </el-form-item>
        <el-form-item label="参考价格">
          <div v-if="info.currency_type == 2">A${{ info.price }}</div>
          <div v-else>￥{{ info.price }}</div>
        </el-form-item>
        <el-form-item label="已售">
          <div>{{ info.sell }}</div>
        </el-form-item>
        <el-form-item label="库存">
          <div>{{ info.stock }}</div>
        </el-form-item>
        <el-form-item label="类型">
          <div>
            <span v-if="info.type == 2">路线</span>
            <span v-else>套餐</span>
          </div>
        </el-form-item>
        <el-form-item label="审核状态">
          <div>
            <span v-if="info.inspect_status == 1">已通过</span>
            <span v-else-if="info.inspect_status == 0">待审核</span>
            <span v-else>已驳回</span>
          </div>
        </el-form-item>
        <el-form-item label="状态">
          <div>
            <span v-if="info.status == 1">正常</span>
            <span v-else style="color:red;">已下架</span>
          </div>
        </el-form-item>
        <el-form-item label="特价套餐">
          <div>
            <span v-if="info.special_offer == 0" style="color:red;">否</span>
            <span v-else>是</span>
          </div>
        </el-form-item>
        <!-- <el-form-item label="新品独家">
          <div>
            <span v-if="info.new_product == 0" style="color:red;">否</span>
            <span v-else>是</span>
          </div>
        </el-form-item>
        <el-form-item label="排序权重">
          <div>{{ info.weight }}</div>
        </el-form-item>-->
      </el-form>
    </el-dialog>

    <el-dialog
      title="推荐"
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
      width="430px"
    >
      <el-form
        ref="recommend"
        :model="recommend"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left:50px;"
      >
        <el-checkbox-group v-model="recommend.category_recommend_ids" size="small">
          <el-checkbox
            v-for="product_category_recommend in product_category_recommend_list"
            :label="product_category_recommend.id"
            :key="product_category_recommend.id"
            style="display:block;"
          >{{ product_category_recommend.tag }}</el-checkbox>
        </el-checkbox-group>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">返回</el-button>
        <el-button type="primary" @click="saveRecommend" :loading="btnLoading">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="权重"
      :visible.sync="dialogWeightFormVisible"
      :close-on-click-modal="false"
      width="430px"
    >
      <el-form
        ref="weight"
        :model="weight"
        label-position="left"
        label-width="50px"
        style="width: 300px; margin-left:6px;"
      >
        <el-form-item label="权重" prop="weight" label-width="50px">
          <el-input v-model="weight.weight" placeholder="请输入权重" value="weight.weight" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogWeightFormVisible = false">返回</el-button>
        <el-button type="primary" @click="saveWeight" :loading="btnLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import uploadList from "@/components/UploadList";
import uploadOne from "@/components/UploadOne";
import Tinymce from "@/components/Tinymce";
import { setTimeout } from 'timers';

export default {
  components: { Tinymce, uploadOne, uploadList },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      examine_id: "",
      refuse_reason: "",
      reasonVisible: false,
      examineVisible: false,
      product_category_recommend_list: [],
      list: null,
      info: null,
      total: null,
      weight: {
        id: null,
        weight: null
      },
      listLoading: true,
      btnLoading: false,
      checkList: [],
      listQuery: {
        page: 1,
        limit: 50,
        shop_name: null,
        title: null,
        type: null,
        inspect_status: null,
        special_offer: null,
        new_product: null,
        sort: "created_at",
        firstDestination:null,
        secondDestination:null,
        thirdDestination:null
      },
      recommend: {
        product_id: null,
        category_recommend_ids: []
      },
      formInline: {
        user: "",
        region: "正常"
      },

      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogWeightFormVisible: false,
      showInfo: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "新增"
      },
      dialogPvVisible: false,
      pvData: [],

      form: {
        id: "",
        shop_id: "",
        title: "",
        cover: "",
        images: [],
        price: "",
        vip_price: "",
        kid_price: "",
        reserve: "",
        group_price: "",
        group_num: "",
        first_destination: "",
        second_destination: "",
        third_destination: "",
        sell: "0",
        novel: "",
        price_include: "",
        price_not_include: "",
        stock: "",
        package_name: "",
        description: "",
        instructions: "",
        return_modify: "",
        type: 1,
        inspect_status: "1",
        status: "1",
        special_offer: "1",
        new_product: "1",
        weight: "1",
        expired: "2020-12-12",
        product_category: [
          {
            id: "",
            parent_id: "",
            parent_parent_id: "",

            pivot: {
              product_id: "",
              product_category_id: ""
            }
          }
        ],
        product_package: [
          {
            id: "",
            product_id: "",
            shop_id: "",
            title: "",
            live_time: "",
            introduce: ""
          }
        ],
        product_recommend: [
          // {
          // id: "",
          // product_id: "",
          // title: "",
          // price: "",
          // origin_price: "",
          // shop_id: "",
          // introduce: ""
          // }
        ]
      },
      rules: {
        create: {
          username: [
            { required: true, message: "用户名不能为空", trigger: "change" }
          ],
          password: [
            { required: true, message: "密码不能为空", trigger: "change" }
          ]
        },
        update: {
          username: [
            { required: true, message: "用户名不能为空", trigger: "change" }
          ]
        }
      },
      //角色复选框
      checkAllRoles: false,
      isIndeterminateRoles: false,
      allRoles: [],
      //权限复选框
      checkAllPermissions: false,
      isIndeterminatePermissions: false,
      allPermissions: [],
      //按钮提交loading
      btnLoading: false,
      firstList: [],
      secondList: [],
      thirdList: [],
      
    };
  },
  created() {
    this.getList();
    // this.getRoleAll();
    // this.getPermissionAll();
    // this.getFatherCategoryList(1, 0, 1);
    // this.getFatherCategoryList(2, 0, 1);
    this.getCategoryList(1);
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/product",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    refuse() {
      this.listLoading = true;
      request({
        url: "/api/backend/product/reject",
        method: "post",
        data: { id: this.examine_id, refuse_reason: this.refuse_reason }
      }).then(response => {
        this.$notify({
          title: "成功",
          message: "驳回成功",
          type: "success",
          duration: 2000
        });
        this.getList();
        this.examineVisible = false;
        this.reasonVisible = false;
        this.listLoading = false;
      });
    },
    getRoleAll() {
      request({
        url: "/api/backend/role/all",
        method: "get",
        params: {}
      }).then(response => {
        this.allRoles = response.data;
      });
    },
    getPermissionAll() {
      request({
        url: "/api/backend/permission/all",
        method: "get",
        params: {}
      }).then(response => {
        this.allPermissions = response.data;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      (this.form = {
        id: "",
        shop_id: "",
        title: "",
        cover: "",
        images: [],
        price: "",
        vip_price: "",
        kid_price: "",
        reserve: "",
        group_price: "",
        group_num: "",
        first_destination: "",
        second_destination: "",
        third_destination: "",
        sell: "0",
        novel: "",
        price_include: "",
        price_not_include: "",
        stock: "",
        package_name: "",
        description: "",
        instructions: "",
        return_modify: "",
        type: 1,
        inspect_status: "1",
        status: "1",
        special_offer: "1",
        new_product: "1",
        weight: "1",
        expired: "2020-12-12",
        product_category: [
          {
            id: "",
            parent_id: "",
            parent_parent_id: "",

            pivot: {
              product_id: "",
              product_category_id: ""
            }
          }
        ],
        product_package: [
          {
            id: "",
            product_id: "",
            shop_id: "",
            title: "",
            live_time: "",
            introduce: ""
          }
        ],
        product_recommend: [
          // {
          //   id: "",
          //   product_id: "",
          //   title: "",
          //   price: "",
          //   origin_price: "",
          //   shop_id: "",
          //   introduce: ""
          // }
        ]
      }),
        (this.btnLoading = false);
      this.checkAllRoles = false;
      this.isIndeterminateRoles = false;
      this.checkAllPermissions = false;
      this.isIndeterminatePermissions = false;
    },

    handleCreate() {
      this.$router.push("/product/store");
      // this.resetForm();
      // this.dialogStatus = "create";
      // this.dialogFormVisible = true;
      // this.getShopList();
      // this.$nextTick(() => {
      //   this.$refs["form"].clearValidate();
      // });
    },
    handleUpdate(id) {
      this.$router.push("/product/store?id=" + id);
    },

    handleShowInfo(row) {
      this.info = row;
      this.showInfo = true;
    },
    recommendUpdate(id) {
      this.checkList = [];
      request({
        url: "/api/backend/categoryRecommend",
        method: "get",
        params: { product_id: id }
      }).then(res => {
        this.product_category_recommend_list = res.data.data;
        let checklist = [];
        this.product_category_recommend_list.forEach(function(item, index) {
          if (item.is_product_recommend) {
            checklist.push(item.id);
          }
        });
        this.recommend.category_recommend_ids = checklist;
        // console.log(this.product_category_recommend_list);

        this.dialogStatus = "recommend";
        this.dialogFormVisible1 = true;
        this.recommend.product_id = id;
      });
    },
    saveRecommend() {
      //       console.log(this.checkList);
      // this.recommend.checkList=this.checkList;

      this.$refs["recommend"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/product/setRecommend",
            method: "post",
            data: this.recommend
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogFormVisible1 = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    examine(id, refuse_reason) {
      this.examine_id = id;
      this.refuse_reason = "";
      this.examineVisible = true;
    },
    toExamine() {
      this.btnLoading = true;
      request({
        url: "/api/backend/product/toExamine",
        method: "post",
        data: { id: this.examine_id }
      })
        .then(response => {
          this.btnLoading = false;
          this.$notify({
            title: "成功",
            message: "审核成功",
            type: "success",
            duration: 2000
          });
          this.getList();
          this.examineVisible = false;
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    weightUpdate(id, weight) {
      (this.weight = {
        id: null,
        weight: null
      }),
        (this.btnLoading = false);
      this.weight.id = id;
      this.weight.weight = weight;
      console.log(this.weight);

      this.dialogWeightFormVisible = true;
      this.$nextTick(() => {
        this.$refs["weight"].clearValidate();
      });
    },
    saveWeight() {
      this.$refs["weight"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/product/setWeight",
            method: "post",
            data: this.weight
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogWeightFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    upDown(id) {
      request({
        url: "/api/backend/product/upDown",
        method: "post",
        data: {'id':id}
      })
        .then(response => {
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000
          });
          this.getList();
        })
        .catch(err => {});
    },
    saveData() {
      if (this.form.type == 1) {
        this.form.shop_id = this.form.product_package[0].shop_id;
      } else {
        this.form.shop_id = 0;
        this.form.reserve = 0;
        this.form.package_name = "package_name";
        this.form.product_package = [];
      }

      this.form.kid_price ? this.form.kid_price : (this.form.kid_price = 15);
      // console.log(this.form);

      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/product",
            method: "post",
            data: this.form
          })
            .then(response => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleDel(val) {
      this.$confirm("此操作将删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/admin/del",
            method: "get",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    onSubmit() {
      this.listQuery.page = 1;
      this.list = [];
      this.getList();
      console.log(this.list);
    },
    addClub() {
      let obj = {
        id: "",
        parent_id: "",
        parent_parent_id: "",

        pivot: {
          product_id: "",
          product_category_id: ""
        }
      };
      this.form.product_category.push(obj);
    },
    delClub(idx) {
      this.form.product_category.splice(idx, 1);
    },
    addPackage() {
      let obj = {
        id: "",
        product_id: "",
        shop_id: "",
        title: "",
        live_time: "0",
        introduce: ""
      };
      this.form.product_package.push(obj);
    },
    delPackage(idx) {
      this.form.product_package.splice(idx, 1);
    },
    addRecommend() {
      let obj = {
        id: "",
        product_id: "",
        title: "",
        price: "",
        origin_price: "",
        shop_id: "",
        introduce: ""
      };
      this.form.product_recommend.push(obj);
    },
    delRecommend(idx) {
      this.form.product_recommend.splice(idx, 1);
    },
    getFatherCategoryList(type, index, level, all = true) {
      var parent_id;
      if (level == 2) {
        if (type == 1) {
          if (all) {
            this.form.product_category[index].parent_id = "";
            this.form.product_category[index].id = "";
          }
          parent_id = this.form.product_category[index].parent_parent_id;
        } else {
          if (all) {
            this.form.second_destination = "";
            this.form.third_destination = "";
          }
          parent_id = this.form.first_destination;
        }
      } else if (level == 3) {
        type == 1
          ? (parent_id = this.form.product_category[index].parent_id)
          : (parent_id = this.form.second_destination);
      }
      if (level != 1) {
        request({
          url: "/api/backend/productCategory",
          method: "get",
          params: {
            level: level,
            page: 1,
            limit: 9999,
            type: type,
            parent_id: parent_id
          }
        }).then(response => {
          if (level == 2) {
            type == 1
              ? (this.secondList = response.data.data)
              : (this.secondDestinationList = response.data.data);
          } else if (level == 3) {
            type == 1
              ? (this.thirdList = response.data.data)
              : (this.thirdDestinationList = response.data.data);
          }
        });
      } else {
        request({
          url: "/api/backend/productCategory",
          method: "get",
          params: { level: level, page: 1, limit: 9999, type: type }
        }).then(response => {
          type == 1
            ? (this.firstList = response.data.data)
            : (this.firstDestinationList = response.data.data);
        });
      }
      // if (!type) {
      //   this.form.parent_id = "";
      // }
      // if (this.first_id) {
      //   request({
      //     url: "/api/backend/productCategory",
      //     method: "get",
      //     params: { parent_id: this.first_id, page: 1, limit: 9999, type: 2 }
      //   }).then(response => {
      //     this.secondList = response.data.data;
      //   });
      //   return;
      // }
      // this.first_id = "";
      // this.form.parent_id = "";
      // request({
      //   url: "/api/backend/productCategory",
      //   method: "get",
      //   params: { level: 1, page: 1, limit: 9999, type: 2 }
      // }).then(response => {
      //   this.fatherList = response.data.data;
      // });
    },
    
    getCategoryList(level) {
      // var parent_id;
      // if (level == 2) {
      //   if (type == 1) {
      //     if(all){
      //       this.listQuery.parent_id = "";
      //     }
      //   }
      // } 
      

      if (level != 1) {
        if(level == 2){
          this.listQuery.secondDestination = null
          this.listQuery.thirdDestination = null
          this.secondList = []
          this.thirdList = []
          request({
            url: "/api/backend/productCategory",
            method: "get",
            params: {
              level: level,
              page: 1,
              limit: 9999,
              type: 2,
              parent_id: this.listQuery.firstDestination
            }
          }).then(response => {
             this.secondList = response.data.data;
          });
        }else{
          this.listQuery.thirdDestination = null
          this.thirdList = []
          request({
            url: "/api/backend/productCategory",
            method: "get",
            params: {
              level: level,
              page: 1,
              limit: 9999,
              type: 2,
              parent_id: this.listQuery.secondDestination
            }
          }).then(response => {
              this.thirdList = response.data.data;
          });
        }

      } else {
        request({
          url: "/api/backend/productCategory",
          method: "get",
          params: { level: level, page: 1, limit: 9999, type: 2 }
        }).then(response => {
          this.firstList = response.data.data
           ;
        });
      }
    },
    firstClose(){
      this.listQuery.secondDestination = null
      this.listQuery.thirdDestination = null
      this.secondList = []
      this.thirdList = []
      // this.$forceUpdate()
      console.log(this.secondList)
      console.log(this.thirdList)
    },
    secondClose(){
      this.listQuery.thirdDestination = null
      this.thirdList = []
      // this.$forceUpdate()
      console.log(this.thirdList)
    }


  }
  
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
